<template>
  <div class="branded-fare-upsell mb-2">
    <div v-if="render_slider && is_mobile()" class="branded-fare-upsell--slider d-block d-md-none">
      <div v-if="loading">
        <!-- la risposta alle branded tarda leggermente ad arrivare, lascio uno spinner nell'attesa per evitare uno scatto inatteso dell'interfaccia che può spiazzare -->
        <!--<b-spinner />-->
        <loader class="my-4" :show_timing_slot="true" />
      </div>
      <content-section
        v-else-if="flight_offers_upsell.length > 0"
        :icon="svg_flight_ticket()"
        title="Tariffe"
        description="Il costo si intende per tutti i passeggeri. I servizi inclusi sono soggetti a regole e condizioni della compagnia e, in alcuni casi, l'esercizio di alcune opzioni incluse (modifiche, cancellazione, ecc.) può richiedere costi aggiuntivi."
      >
        <div class="branded-fare-upsell--content">
          <div v-html="chevron_left" class="branded-fare-upsell--prev"></div>
          <div v-html="chevron_right" class="branded-fare-upsell--next"></div>
          <slick :ref="slick_ref" :options="slick_options" @init="initialize_slick">
            <div
              class="branded-fare-upsell--wrapper"
              v-for="(item, index) in flight_offers_upsell"
              :key="`${_uid}:${item.id}:${index}`"
              :class="item.id == selected_flight_offer_id ? 'selected' : ''"
            >
              <div class="panel" compact>
                <div class="branded-fare-upsell--title">
                  {{ get_selected_fare(item) | capitalize }}
                </div>
                <div class="branded-fare-upsell--price">
                  {{ apply_markup_to_number(item, item.price.grandTotal) }}
                  {{ item.price.currency }}
                </div>
                <div class="branded-fare-upsell--separator fullwidth"></div>

                <div class="branded-fare-upsell--amenity--top" v-if="true">
                  <div class="branded-fare-upsell--amenity--icon">
                    <div v-html="get_amenity_info({ code: '0CH' }).icon"></div>
                  </div>
                  <div class="branded-fare-upsell--amenity--name d-flex">
                    {{ get_amenity_info({ code: '0CH' }).txt }}:
                    {{ parse_fligth_offer_bags(item).total }}
                  </div>
                </div>
                <div class="branded-fare-upsell--separator fullwidth"></div>

                <div class="branded-fare-upsell--amenity--top" v-if="true">
                  <div class="branded-fare-upsell--amenity--icon">
                    <div
                      v-html="
                        get_amenity_info({
                          code: '',
                          description: 'Servizi inclusi',
                        }).icon
                      "
                    ></div>
                  </div>
                  <div class="branded-fare-upsell--amenity--name d-flex">
                    {{
                      get_amenity_info({
                        code: '',
                        description: 'Servizi inclusi',
                      }).txt
                    }}:
                    {{
                      Object.keys(
                        item.travelerPricings[0].fareDetailsBySegment[0].amenities.filter(
                          function (a) {
                            return show_amenity(a);
                          }
                        )
                      ).length
                    }}
                  </div>
                </div>

                <div>
                  <div class="branded-fare-upsell--show-all" v-b-modal="'modal-' + _uid + index">
                    Vedi tutti i servizi
                  </div>

                  <b-modal
                    :id="'modal-' + _uid + index"
                    title="Servizi inclusi"
                    size="lg"
                    modal-class="branded-fare-upsell--modal"
                    hide-footer
                  >
                    <amenity
                      class="branded-fare-upsell--amenity"
                      v-for="(
                        amenity, amenity_index
                      ) in item.travelerPricings[0].fareDetailsBySegment[0].amenities.filter(
                        function (a) {
                          return show_amenity(a);
                        }
                      )"
                      :key="`amenities:${_uid}:${amenity_index}-all`"
                      :item="get_amenity_info(amenity)"
                    >
                      <div class="branded-fare-upsell--amenity--wrapper" slot-scope="{ item }">
                        <div class="branded-fare-upsell--amenity--top">
                          <div class="branded-fare-upsell--amenity--icon">
                            <div v-if="item.icon" v-html="item.icon"></div>
                          </div>
                          <div class="branded-fare-upsell--amenity--text">
                            <div class="branded-fare-upsell--amenity--name d-flex" v-if="item.txt">
                              <div>{{ item.txt | capitalize }}</div>
                              <div
                                class="ml-1"
                                v-if="item.tooltip"
                                v-b-popover.hover.top="item.tooltip"
                                v-html="info"
                              ></div>
                            </div>
                            <div
                              class="branded-fare-upsell--amenity--description"
                              v-if="item.description"
                            >
                              {{ item.description | capitalize }}
                            </div>
                          </div>
                        </div>
                        <div class="branded-fare-upsell--separator fullwidth"></div>
                      </div>
                    </amenity>
                  </b-modal>
                </div>
                <div class="branded-fare-upsell--actions">
                  <div>
                    <!--flexbox-->
                    <b-button
                      v-if="item.id !== selected_flight_offer_id"
                      variant="tertiary"
                      @click="() => select_flight_offer(item)"
                      block
                    >
                      Scegli
                    </b-button>
                    <!-- se ho selezionato la tariffa base NON posso rimuoverla ma solo cambiarla. il tasto rimuovi in quel caso è disabled -->
                    <b-button
                      v-if="item.id == selected_flight_offer_id"
                      variant="outline-tertiary"
                      @click="() => select_flight_offer(flight_offer_default)"
                      :disabled="item.id == flight_offer_default.id"
                      block
                    >
                      Rimuovi
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </slick>
        </div>
      </content-section>
    </div>

    <div v-if="render_table && !is_mobile()" class="branded-fare-upsell--table d-none d-md-block">
      <div v-if="loading">
        <!-- la risposta alle branded tarda leggermente ad arrivare, lascio uno spinner nell'attesa per evitare uno scatto inatteso dell'interfaccia che può spiazzare -->
        <!--<b-spinner />-->
        <loader class="my-4" :show_timing_slot="true" />
      </div>
      <content-section
        v-else-if="flight_offers_upsell.length > 0"
        :icon="svg_flight_ticket()"
        title="Tariffe"
        description="Il costo si intende per tutti i passeggeri. I servizi inclusi sono soggetti a regole e condizioni della compagnia e, in alcuni casi, l'esercizio di alcune opzioni incluse (modifiche, cancellazione, ecc.) può richiedere costi aggiuntivi."
      >
        <template>
          <div class="branded-fare-upsell--table--scrollable">
            <table class="table table-responsive-md">
              <thead>
                <tr class="table--sticky-row sticky-top">
                  <td>Tariffa</td>
                  <td
                    v-for="(item, index) in flight_offers_upsell"
                    :key="`head:${_uid}:${item.id}:${index}`"
                    :class="item.id == selected_flight_offer_id ? 'selected' : ''"
                  >
                    {{ get_branded_fare(item) | capitalize }}
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(amenity, a_index) in table_amenities"
                  :key="`amenities:${_uid}:${a_index}-all`"
                >
                  <td>
                    <amenity class="branded-fare-upsell--amenity" :item="get_amenity_info(amenity)">
                      <div class="branded-fare-upsell--amenity--wrapper" slot-scope="{ item }">
                        <div class="branded-fare-upsell--amenity--top">
                          <div class="branded-fare-upsell--amenity--icon">
                            <div
                              class="d-flex align-items-center justify-content-center"
                              v-if="item.icon"
                              v-html="item.icon"
                            ></div>
                          </div>
                          <div class="branded-fare-upsell--amenity--text">
                            <div class="branded-fare-upsell--amenity--name" v-if="item.txt">
                              <div>{{ item.txt | capitalize }}</div>
                              <div
                                class="ml-1"
                                v-if="item.tooltip"
                                v-b-popover.hover.top="item.tooltip"
                                v-html="info"
                              ></div>
                            </div>
                            <div
                              class="branded-fare-upsell--amenity--description"
                              v-if="item.description"
                            >
                              {{ item.description | capitalize }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </amenity>
                  </td>
                  <td
                    v-for="(item, f_index) in flight_offers_upsell"
                    :key="`body:${_uid}:${item.id}:${f_index}`"
                    :class="item.id == selected_flight_offer_id ? 'selected' : ''"
                  >
                    <div
                      :class="`table--amenity--${
                        is_amenity_present(item.id, amenity.code) ? 'ok' : 'ko'
                      }`"
                      v-html="check_mark(color_primary, 18)"
                    ></div>
                  </td>
                </tr>
                <tr class="table--sticky-row">
                  <td></td>
                  <td
                    v-for="(item, f_index) in flight_offers_upsell"
                    :key="`action:${_uid}:${item.id}:${f_index}`"
                    :class="item.id == selected_flight_offer_id ? 'selected' : ''"
                  >
                    <div class="branded-fare-upsell--price">
                      {{ apply_markup_to_number(item, item.price.grandTotal) }}
                      {{ item.price.currency }}
                    </div>
                    <div class="branded-fare-upsell--actions">
                      <div>
                        <!--flexbox-->
                        <b-button
                          v-if="item.id !== selected_flight_offer_id"
                          variant="tertiary"
                          @click="() => select_flight_offer(item)"
                          block
                        >
                          Scegli
                        </b-button>
                        <!-- se ho selezionato la tariffa base NON posso rimuoverla ma solo cambiarla. il tasto rimuovi in quel caso è disabled -->
                        <b-button
                          v-if="item.id == selected_flight_offer_id"
                          variant="outline-tertiary"
                          :disabled="item.id == flight_offer_default.id"
                          @click="() => select_flight_offer(flight_offer_default)"
                          block
                        >
                          Rimuovi
                        </b-button>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>
      </content-section>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Slick from 'vue-slick';
import { get_flight_offers_upsell } from '@/api';
import {
  apply_markup_to_number,
  select_flight_offer,
  parse_fligth_offer_bags,
} from '@/flight-offer';
import { get_amenity_info } from '@/resources';
import { max } from 'mathjs';
import { chevron_left, chevron_right } from '@/components/svg/chevrons';
import { flight_ticket } from '@/components/svg/flight';
import { info } from '@/components/svg/common';
import { is_mobile } from '@/utilities';
import Loader from '@/components/blocks/loader';
import ContentSection from '@/components/blocks/wrappers/content-section.vue';
import { check_mark } from '@/components/svg';
import { color_primary } from '@/resources/colors';

export default {
  name: 'branded-fare-upsell',
  props: {
    render_slider: Boolean,
    render_table: Boolean,
    flight_offer: Object,
  },
  components: {
    'content-section': ContentSection,
    slick: Slick,
    amenity: {
      render() {
        return this.$scopedSlots.default(this.$attrs);
      },
    },
    loader: Loader,
  },
  created() {
    this.get_flight_offers_upsell = get_flight_offers_upsell;
    this.apply_markup_to_number = apply_markup_to_number;
    this.select_flight_offer = select_flight_offer;
    this.get_amenity_info = get_amenity_info;
    this.chevron_left = chevron_left;
    this.chevron_right = chevron_right;
    this.info = info;
    this.parse_fligth_offer_bags = parse_fligth_offer_bags;
    this.is_mobile = is_mobile;
  },
  data() {
    return {
      color_primary,
      loading: true,
      flight_offer_default: {},
      flight_offers_upsell: [],
      visible_amenities: 4,
      slick_ref: `slick_${this._uid}`,
      slick_options: {
        infinite: true,
        speed: 1000,
        dots: false,
        slidesToShow: 3,
        draggable: false,
        prevArrow: '.branded-fare-upsell--prev',
        nextArrow: '.branded-fare-upsell--next',
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              //slidesToScroll: 3,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              //slidesToScroll: 2
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              //slidesToScroll: 1
            },
          },
        ],
      },
      //tabella
      table_amenities: [],
      offers_amenities: {},
    };
  },
  computed: {
    dictionaries: {
      get() {
        return this.$store.state.liveflight.results.dictionaries;
      },
      set(value) {
        this.$store.commit('dictionaries', value);
      },
    },
    travelers: {
      get() {
        return this.$store.state.liveflight.travelers;
      },
      set(value) {
        this.$store.commit('travelers', value);
      },
    },
    selected_flight_offer_id() {
      return this.get_selected_fare(this.flight_offers_upsell, this.flight_offer).id;
    },
  },
  mounted() {
    this.loading = true;
    this.$store.commit('flight_offer_has_upsell', false);
    this.get_flight_offers_upsell({
      priceFlightOffersBody: {
        data: {
          type: 'flight-offers-pricing',
          flightOffers: [this.flight_offer],
        },
      },
    }).then(
      (response) => {
        if (!response.data.data) {
          this.loading = false;
          return;
        }

        const flight_offer_data = response.data.data;
        this.flight_offer_default = flight_offer_data[0];
        this.flight_offers_upsell = this.filter_visible_upsells(
          flight_offer_data[0],
          flight_offer_data
        );

        this.$store.commit('flight_offer_has_upsell', this.flight_offers_upsell.length > 0);

        this.flight_offers_upsell.forEach((f) => {
          this.offers_amenities[f.id] = [];

          if (!f.travelerPricings[0].fareDetailsBySegment[0].amenities) {
            // lccs con branded fares ma senza amenities
            f.travelerPricings[0].fareDetailsBySegment[0].amenities = [
              {
                code: 'XXX',
                description: 'FARE',
                isChargeable: false,
                amenityType: 'MISSING_AMENITIES',
              },
            ];
          }

          f.travelerPricings[0].fareDetailsBySegment[0].amenities.forEach((amenity) => {
            if (amenity.isChargeable == false) {
              // inclusa in questa tariffa

              if (this.table_amenities.filter((a) => a.code === amenity.code).length == 0)
                this.table_amenities.push(amenity);

              this.offers_amenities[f.id].push(amenity.code);
            }
          });
        });

        this.loading = false;
      },
      () => {
        this.loading = false;
      }
    );
  },
  methods: {
    check_mark,
    svg_flight_ticket: flight_ticket,
    is_amenity_present(offer_id, amenity_code) {
      return (this.offers_amenities[offer_id] || []).includes(amenity_code);
    },
    get_visible_amenities(amenities) {
      let _this = this;
      amenities = amenities.filter(function (a) {
        return _this.show_amenity(a);
      });
      return amenities.slice(0, this.visible_amenities);
    },
    get_hidden_amenities(amenities) {
      let _this = this;
      amenities = amenities.filter(function (a) {
        return _this.show_amenity(a);
      });
      if (amenities.length <= this.visible_amenities) return [];
      return amenities.slice(-(amenities.length - this.visible_amenities));
    },
    get_branded_fare(flight_offer) {
      try {
        return flight_offer.travelerPricings[0].fareDetailsBySegment[0].brandedFare;
      } catch {
        return undefined;
      }
    },
    get_selected_fare(flight_offers_upsell, flight_offer_data) {
      const default_branded_fare = this.get_branded_fare(flight_offer_data);
      for (let index = 0; index < flight_offers_upsell.length; index++) {
        const upsell = flight_offers_upsell[index];
        if (default_branded_fare === this.get_branded_fare(upsell)) {
          return upsell;
        }
      }
      return flight_offer_data;
    },
    show_amenity(amenity) {
      if (amenity.isChargeable) return false;
      return true;
    },
    show_flight_offer(fare_details_by_segment) {
      const branded_fare = fare_details_by_segment[0].brandedFare;
      for (let s = 0; s < fare_details_by_segment.length; s += 1) {
        if (fare_details_by_segment[s].brandedFare !== branded_fare) {
          return false;
        }
      }
      return true;
    },
    is_visible_upsell(f, default_offer) {
      return (
        this.get_branded_fare(default_offer) !== this.get_branded_fare(f) &&
        this.show_flight_offer(f.travelerPricings[0].fareDetailsBySegment) &&
        this.travelers.length === f.travelerPricings.length
      );
    },
    filter_visible_upsells(default_offer, upsells) {
      // mostro solo branded "omogenee" (stessa brandedFare per tutti pax/segmenti)
      // e con stesso numero di pax
      // mostro sempre però la tariffa selezionata
      const filtered = [];
      if (Vue.prototype.$config) {
        const { brandedUpsell = {} } = Vue.prototype.$config.guiSettings || {};
        const max_upsells_count = Math.max(0, (brandedUpsell.show || 1) - 1);
        filtered.push(
          ...upsells
            .filter((f) => this.is_visible_upsell(f, default_offer))
            .slice(0, max_upsells_count)
        );
      }
      return [default_offer, ...filtered];
    },
    initialize_slick(event, slick) {
      try {
        // Slide to selected flight offer index
        const selectedIndex = this.flight_offers_upsell.findIndex(
          (upsell) => this.get_branded_fare(this.flight_offer) === this.get_branded_fare(upsell)
        );
        if (slick && slick.slickGoTo) {
          slick.slickGoTo(max(0, selectedIndex));
        }
      } catch (e) {
        this.log('branded-fare-upsell.mounted.then', e);
      }
    },
  },
};
</script>

<style lang="scss">
.branded-fare-upsell {
  &--top {
    display: flex;
    margin-bottom: 0;
  }
  &--heading {
    flex: 1;
  }
  &--content {
    margin-bottom: $grid-gutter-width;
    width: calc(100% + #{$grid-gutter-width/2});
    margin-left: -$grid-gutter-width/4;
    .slick-track {
      display: flex !important;
      float: left;
      margin-left: 0;
    }
    .slick-slide {
      height: auto !important;
    }
    padding: 0 20px;
    position: relative;
  }
  &--arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    padding: 6px;
    z-index: 1;
    cursor: pointer;
    svg {
      width: 14px;
      height: 14px;
    }
  }
  &--prev,
  &--next {
    @extend .branded-fare-upsell--arrow;
    &.branded-fare-upsell--prev {
      left: 0;

      svg {
        transform: rotate(-90deg);
      }
    }
    &.branded-fare-upsell--next {
      right: 0;

      svg {
        transform: rotate(90deg);
      }
    }
  }
  &--wrapper {
    height: 100%;
    .panel {
      height: 100%;
      margin-top: 0;
      margin: 0 $grid-gutter-width/4;
      max-width: calc(100% - 2px - #{$grid-gutter-width/2});
      display: flex;
      flex-direction: column;
      .content {
        padding: 6px 0;
      }
    }

    &:not(.selected) {
      .panel {
        * {
          fill: $green;
        }
      }
    }
    &.selected {
      .panel {
        background-color: $gray-100;
        border: 2px solid $primary;
        margin-bottom: -1px;
        .fullwidth,
        * > div {
          border-color: $gray-200;
        }
      }
    }
  }
  &--title {
    font-size: 16px;
    text-transform: capitalize;
  }
  &--price {
    font-size: 14px;
    //@include font-primary-bold;
  }
  &--amenity {
    &--wrapper {
      display: flex;
      flex-direction: column;
    }
    &--top {
      display: flex;
      flex-wrap: nowrap;
      flex: 1;
      align-items: center;
    }
    &--icon {
      width: 28px;
      margin-right: 5px;
    }
    &--text {
      flex: 1;
      font-size: 14px;
      white-space: nowrap;
      @include font-primary-regular;
    }
    &--name {
      display: flex;
      align-items: center;
      svg {
        --fill: #{$primary} !important;
        width: 14px;
        height: 14px;
      }
    }
  }
  &--actions {
    margin-top: $grid-gutter-width/2;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }
  &--separator {
    @extend .panel--separator !optional;
    width: 100%;
    margin-top: 13px;
    margin-bottom: 13px;
  }
  &--show-all {
    cursor: pointer;
    text-decoration: underline;
    font-size: $font-size-sm;
    color: $cta;
    text-align: right;
    margin-top: $grid-gutter-width;
  }
  &--modal {
    .modal-content {
      overflow: hidden;
      padding-bottom: $grid-gutter-width/2;
    }
    .modal-body {
      @include media-breakpoint-up(md) {
        display: grid;
        grid-template-columns: 50% 50%;
        .branded-fare-upsell--amenity--wrapper {
          height: 100%;
        }
      }
    }
  }

  &--table {
    &--scrollable {
      max-height: 455px;
      overflow-y: auto;
    }
    .table {
      thead {
        .sticky-top {
          background-color: #f8f9fa;
        }
      }

      &--sticky-row {
        position: sticky;
        bottom: 0;
        background: $white;

        .branded-fare-upsell--actions {
          margin-top: 10px;
        }
        td {
          position: relative;
          &:before {
            content: '';
            position: absolute;
            bottom: 100%;
            left: 0;
            width: 100%;
            height: 40px;
            background: linear-gradient(180deg, transparent 0%, $white 100%) !important;
          }
        }
      }
      tr:nth-last-child(2) {
        td {
          padding-bottom: 40px;
        }
      }

      td {
        text-align: center;
        font-weight: bold;
        &:first-child {
          text-align: left;
          //width:240px;
        }
        &.selected {
          background: $light-blue;
          color: $primary;
          &:before {
            background: linear-gradient(180deg, transparent 0%, $light-blue 100%) !important;
          }
          .table--amenity--ok svg path {
            fill: $primary;
          }
          .table--amenity--ko svg path {
            fill: $gray-400;
          }
        }
      }

      &--amenity {
        &--ok {
          svg path {
            fill: $green;
          }
        }
        &--ko {
          svg path {
            fill: $gray-400;
          }
        }
      }
    }
  }
}
</style>
